import { Component } from "react";
import { AlertTriangle, Lock, LogIn, RefreshCw, ShieldOff, Wrench } from "lucide-react";

const ICONS = { expired: LogIn, denied: Lock, setup: Wrench, unavailable: RefreshCw, error: AlertTriangle, membership: ShieldOff };

export function StateScreen({ kind = "error", title, text, actions, refId, testid = "app-state" }) {
  const Icon = ICONS[kind] || AlertTriangle;
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#FBF9F5]" data-testid={testid} role="alert">
      <div className="w-full max-w-md card-surface p-6 md:p-8">
        <div className="font-display text-3xl mb-4">86'd</div>
        <div className="h-11 w-11 rounded-full bg-[#F3EFE6] flex items-center justify-center mb-4"><Icon className="h-5 w-5 text-stone-700" /></div>
        <h1 className="font-display text-2xl mb-2" data-testid={`${testid}-title`}>{title}</h1>
        <p className="text-sm text-stone-600" data-testid={`${testid}-text`}>{text}</p>
        {actions && <div className="mt-6 flex flex-col sm:flex-row gap-2">{actions}</div>}
        {refId && <p className="mt-5 text-[11px] text-stone-400 font-mono" data-testid={`${testid}-ref`}>Reference: {refId}</p>}
      </div>
    </div>
  );
}

export const StateButton = ({ children, primary, ...p }) => (
  <button type="button" {...p} className={`h-11 px-5 rounded-lg text-sm font-semibold inline-flex items-center justify-center focus:outline-none focus-visible:ring-2 focus-visible:ring-stone-900/40 ${primary ? "bg-stone-900 text-white" : "border border-[#E6E1D7] bg-white"}`}>{children}</button>
);

const newRef = () => Math.random().toString(36).slice(2, 10).toUpperCase();

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { ref: null };
  }

  static getDerivedStateFromError() {
    return { ref: newRef() };
  }

  componentDidCatch(error) {
    console.error(`[86d] render error ref=${this.state.ref || ""}`, error?.message);
  }

  render() {
    if (!this.state.ref) return this.props.children;
    if (this.props.inline) return (
      <div className="card-surface p-5 flex items-start gap-3" data-testid="widget-error" role="alert">
        <AlertTriangle className="h-5 w-5 text-amber-700 mt-0.5" />
        <div className="text-sm"><div className="font-medium">This section couldn't be displayed</div>
          <button type="button" className="underline mt-1" onClick={() => this.setState({ ref: null })} data-testid="widget-error-retry">Try again</button>
          <span className="ml-3 text-[11px] text-stone-400 font-mono">Ref {this.state.ref}</span></div>
      </div>);
    return (
      <StateScreen kind="error" testid="page-error" title="Something went wrong on this page" refId={this.state.ref}
        text="The rest of your account is fine. Reload to try again — if it keeps happening, share the reference with 86'd support."
        actions={<><StateButton primary onClick={() => window.location.reload()} data-testid="page-error-reload">Reload</StateButton>
          <StateButton onClick={() => { window.location.href = "/app/today"; }} data-testid="page-error-home">Go to Today</StateButton></>} />
    );
  }
}
